import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LoadingPage from '../LoadingPage';
import Kanban from './Kanban';
import ApiService from '../../services/ApiService';
import RepairOrderCard from './RepairOrderCard';

const renderTemplate = item => {
  return <RepairOrderCard item={item} />;
};

const RepairOrderBoard = () => {
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState([]);
  const [columnItems, setColumnItems] = useState({});
  const { codes, user } = useSelector(state => state.app);

  const getColumns = () => {
    setLoading(true);

    return ApiService.get('/repair/states').then(response => {
      const { roRaw, cols } = response.data;

      const newColumns = [];
      const newColumnItems = {};

      // Setup Open/Unassigned swimlane
      newColumnItems[0] = [];
      newColumns.push({ name: 'Open' });

      codes.forEach(status => {
        if (status.statusTypeId === 1) {
          newColumns.push(status);
          newColumnItems[status.id] = [];
        }
      });

      roRaw.forEach(ro => {
        const parts = ro.split('ý');
        const row = {};

        parts.forEach((part, index) => {
          row[cols[index].name] = part;
        });

        if (!newColumnItems[row.status]) {
          newColumnItems[0].push({ id: row.roNo, ...row });
          return;
        }
        newColumnItems[row.status].push({ id: row.roNo, ...row });

        return row;
      });

      setColumns(newColumns);
      setColumnItems(newColumnItems);
      setLoading(false);
    });
  };

  const handleChange = (source, dest, item, columns) => {
    const statusId = parseInt(dest.droppableId);
    const key = item.id;

    return ApiService.post('report/shopstatusupdate', { code: statusId, roNo: key, ppc: user.ppc });
  };

  useEffect(() => {
    getColumns();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  const pools = {
    'Repair Orders': columns,
    // Trailers: columns,
  };

  return (
    <Kanban
      name="parts-request"
      pools={pools}
      setColumns={setColumns}
      setColumnItems={setColumnItems}
      columnItems={columnItems}
      renderTemplate={renderTemplate}
      onChange={handleChange}
    />
  );
};

export default RepairOrderBoard;
